var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconInfographic = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.312 2.74548L8.56001 7.49763L13.312 12.2492C14.4375 10.8738 15 9.28976 15 7.49763C15 5.7055 14.4375 4.12088 13.312 2.74548ZM7.49735 8.56033L2.74595 13.3119C4.12129 14.4375 5.70471 15 7.49735 15C9.28941 15 10.8734 14.4375 12.2493 13.3119L7.49735 8.56033ZM12.2493 1.68278L1.68272 12.2492C0.473716 10.7903 -0.0836239 9.09711 0.0101235 7.16893C0.104443 5.24132 0.838988 3.58981 2.21433 2.21385C3.58968 0.838449 5.24112 0.103875 7.16923 0.0101239C9.09677 -0.0836271 10.7899 0.473734 12.2493 1.68278Z",
  fill: "#999999"
}))));
export default SvgIconInfographic;